import type { IUserRepository } from '../repositories/IUserRepository.js';
import type { OrgMembershipEntity } from '../entities/UserEntity.js';

interface Dependencies {
  userRepository: IUserRepository;
}

export function createGetUserOrgMembershipUseCase({ userRepository }: Dependencies) {
  return async function getUserOrgMembership(input: {
    profileId: string;
    orgId: string;
  }): Promise<OrgMembershipEntity | null> {
    return userRepository.getOrgMembership(input.profileId, input.orgId);
  };
}
